import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import SearchOverviewCompare from "./SearchOverviewCompare";
import SearchOverviewSingle from "./SearchOverviewSingle";

interface Params {
    key: string;
}

const SearchOverview: FC = () => {
    const { params } = useCurrentStateAndParams();
    const { key } = params as Params;

    const isCompareMode = key?.split(",").length > 1;

    return (
        <div data-automation="SearchOverview">
            {isCompareMode ? <SearchOverviewCompare /> : <SearchOverviewSingle />}
        </div>
    );
};

export default SearchOverview;
